var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    y: 0,
    x: 0,
    xmlns: "http://www.w3.org/2000/svg",
    id: "\\u5716\\u5C64_1",
    width: "200px",
    height: "200px",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      width: "100%",
      height: "100%",
      backgroundSize: "initial",
      backgroundRepeatY: "initial",
      backgroundRepeatX: "initial",
      backgroundPositionY: "initial",
      backgroundPositionX: "initial",
      backgroundOrigin: "initial",
      backgroundImage: "initial",
      backgroundClip: "initial",
      backgroundAttachment: "initial",
      animationPlayState: "paused"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(0.8, 0.8)",
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M50.853 75.587c-14.746-.255-27.415-5.317-38.728-15.475-1.903-1.708-3.626-3.581-5.06-5.186-2.767-3.098-2.753-6.928.036-9.997C19.47 31.315 33.882 24.412 49.937 24.412c1.203 0 2.434.039 3.658.115 13.121.822 25.235 6.501 36.007 16.878a49.542 49.542 0 0 1 3.517 3.784c2.541 3.023 2.505 6.716-.096 9.637-11.853 13.315-25.974 20.3-41.971 20.76-.041.002-.082.002-.124.002l-.075-.001z",
    style: {
      fill: "rgb(255, 255, 255)",
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464646",
    d: "M89.812 47.969a45.129 45.129 0 0 0-3.207-3.453c-9.322-8.98-20.221-14.859-33.281-15.677-17.517-1.097-31.497 6.305-43.026 18.994-1.312 1.444-1.305 2.765-.011 4.214 1.503 1.682 3.049 3.345 4.725 4.85 9.925 8.912 21.392 14.12 35.916 14.371 15.196-.436 28.244-7.38 38.869-19.313 1.181-1.327 1.159-2.624.015-3.986zm-50.007 8.617a9.158 9.158 0 0 1-8.378-5.465c.284 4.524 2.269 8.787 5.47 12.152-3.983.003-16.298-7.819-20.948-13.386 5.929-6.136 12.803-10.767 21.222-13.621a24.15 24.15 0 0 0-2.945 3.902 9.11 9.11 0 0 1 5.579-1.907 9.163 9.163 0 0 1 0 18.325zm23.094 7.028c7.694-9.167 7.597-18.125.045-27.3 8.301 2.8 15.112 7.424 21.187 13.635-6.047 6.198-12.869 10.812-21.232 13.665z",
    style: {
      fill: "rgb(70, 70, 70)",
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("metadata", {
    xmlnsD: "https://loading.io/stock/",
    style: {
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("dName", {
    style: {
      animationPlayState: "paused"
    }
  }, "eye"), /*#__PURE__*/React.createElement("dTags", {
    style: {
      animationPlayState: "paused"
    }
  }, "visible,publish,public,surveillance,watch,look,see,eye,map"), /*#__PURE__*/React.createElement("dLicense", {
    style: {
      animationPlayState: "paused"
    }
  }, "by"), /*#__PURE__*/React.createElement("dSlug", {
    style: {
      animationPlayState: "paused"
    }
  }, "cwsf7k"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.fb34b3207da59af216073625d9f94a44.svg";
export { ForwardRef as ReactComponent };